interface Props {
    message?: string;
}

const FieldError = ({ message }: Props) => {
    if (!message) return null;
    return (
        <p data-field-error className="mt-1 text-sm text-red">
            {message}
        </p>
    );
};

export default FieldError;
